module.exports = __webpack_public_path__ + "img/subscribe.28ed95c2.svg";